import { Contents } from './types';

const howToContents: Contents = {
  CNC: [
    {
      title: '재료를 꼭 명시해주세요!',
      description: `재료의 종류에 따라 CNC 가공 난이도와 견적가격이 크게 달라질 수 있기 때문애 원하는 재료를 기재하는 것이 중요합니다.  만약 어떤 재료를 선택할 지 모르겠다면 ‘녹이 슬면 안 된다’ ‘탄성이 있어야 한다’는 식으로 제품에 필요한 특성을 적어주세요. 그래야 파트너가 적절한 소재를 추천해 드릴 수 있습니다.`
    },
    {
      title: '‘공차’는 ‘도면’에 자세히 표기해 주세요',
      description: `CNC 가공에서 공차는 견적 가격을 좌우하는 중요한 요소입니다. 공차를 어떻게 설정하느냐에 따라 가공의 난이도, 결과물의 기대되는 품질 등이 달라지는 만큼, 공차를 꼭 기재해주세요.`
    },
    {
      title: '거칠기 등 ‘특이사항’을 꼭 적어주세요',
      description: `기본적인 절삭 가공을 마친 뒤 후가공이 필요할 수 있습니다. 거칠기, 열처리, 평판도 등 부가적으로 고려할 특이사항이 있다면 상세 요청사항에 자세히 적어주세요.`
    },
    {
      title: '예산을 공개해보세요.',
      description: `CNC 가공은 난이도에 따라 가격이 크게 달라질 수 있습니다. 대략적인 예산 범위를 공개하면 예산을 감안한 맞춤형 견적을 받을 확률이 높아집니다.`
    }
  ],
  PRINTING: [
    {
      title: '도면 ‘다운로드’를 허용하세요',
      description: `3D프린팅 업체들은 보통 다운로드한 파일을 별도 소프트웨어에서 실행해 견적을 매깁니다. 제대로 된 견적을 받아보려면 다운로드 권한을 허용하는 것이 필수적입니다.`
    },
    {
      title: '제품의 목적과 용도 기재 필수!',
      description: `3D프린팅 업체측에 제품의 목적과 구체적인 용도를 알려주면 어떤 재료를 어떤 방식으로 출력하는 것이 좋을지 결정해 보다 정확한 견적을 산출할 수 있습니다. ‘상세 요청사항’에 제품의 목적과 용도를 자세히 적어주세요.`
    },
    {
      title: '파일은 부품별로 따로 올려주세요!',
      description: `제품을 통으로 출력하려는 것이 아니라면 각각의 부품에 대한 모델링 파일을 각각 올리는 것이 좋습니다. 구체적인 요청사항 없이 조립된 형태의 소위 ‘어셈블리’ 파일만 올린다면 제품을 쪼개서 출력을 해야 할지 등을 결정할 수가 없어 견적을 내기 어렵습니다.`
    },
    {
      title: '파일 용량을 지나치게 줄이지 마세요!',
      description: `간혹 모델링 파일의 용량을 줄이느라 해상도가 낮은 파일을 첨부하는 경우가 있습니다. 파일 용량이 작은 저해상도의 모델링을 출력하게 되면 화면 상에서 보았던 것과 달리 품질이 낮은, 울퉁불퉁한 결과물이 나오게 됩니다. 가급적 해상도가 확보된 파일을 올려주세요.`
    }
  ],
  INJ: [
    {
      title: '구체적인 제작 수량 기재 필수!',
      description: `제품을 몇 개나 생산할 지 여부에 따라 제작해야 하는 금형의 유형이 달라지고, 금형의 종류가 달라지면 자연히 견적 비용 또한 천차만별로 달라집니다. `
    },
    {
      title:
        '홈이 파져있거나 돌출된 부분이 있다면 가공방식 수정 옵션을 열어두세요!',
      description: `도면 상에서는 쉽게 구현이 가능할 것 같지만 공정의 특성상 생산이 어려운 경우가 있습니다. 금형 사출의 경우 대표적인 사례로 홈이 파져있거나 돌출된 형상 언더컷 구조가 있는데요, 금형 안에서 자동으로 빼내기 어렵습니다. 해결 방법이 다양하기 때문에 반드시 특정 가공방식으로 제작해야하는 경우가 아니라면 상세 요청사항에 가공방식 수정이 가능하다는 점을 적어주시는 것이 좋습니다`
    },
    {
      title: '완제품의 ‘무게’를 적어주세요',
      description: `제품의 사이즈와 재료가 동일하더라도 제품 ‘무게’에 따라 설계가 달라질 수 있습니다. 완제품의 무게를 상세 요청사항에 명시한다면 보다 정확한 견적서를 받아볼 수 있습니다.`
    },
    {
      title: '예산을 공개해보세요.',
      description: `금형 제작 비용은 적게는 수백 만원에서 많게는 수 천만원 이상의 예산이 투입됩니다. 큰 비용이 들어가는 작업인 만큼 대략적인 예산 범위를 공개하면 제조업체 입장에서 예산을 감안해 맞춤형 견적서를 보내올 가능성이 큽니다.`
    }
  ],
  PCB: [
    {
      title: '제작 목적 명시',
      description:
        '제품의 기능 또는 컨셉을 설명해주세요. 참고할 만한 기존 제품이 있다면 첨부파일로 등록해 주세요.',
      examples: [
        '진공관 시계를 만들고 싶습니다.',
        '히터제어 모듈을 만들고 싶습니다.'
      ]
    },
    {
      title: '동작 시나리오 기술',
      description:
        '제품이 구체적으로 어떻게 작동하기를 원하는지, 아래 예시를 참고해 구체적으로 기재해 주세요.',
      examples: [
        '제품의 뚜껑 오픈 시 LED와 모터 중지',
        '버튼 1번 클릭시 작동, 2번 클릭시 작동 중지'
      ]
    },
    {
      title: '스펙 입력',
      description:
        '기판을 구성하는 부품의 구체적인 내역을 입력해주시면 됩니다. 전원/배터리, 부품(온도센서, 히터) 그리고 통신방식 등이 있습니다. 스펙을 구체적으로 적어주시면 설계시간과 비용을 단축할 수 있습니다. ',
      examples: [
        '12V 순환모터 [워터펌프814A]',
        '시작정지타이머 [FK-5102] 9V',
        '수위센서 [FK902] 9V'
      ]
    }
  ],
  DESIGN: [
    {
      title: '제품의 용도와 목적을 상세히 적어주세요',
      description: `기구설계는 다른 서비스처럼 주어진 도면을 보고 제작하는 것이 아닌, 무에서 유를 창조해야하는 서비스입니다. ‘도면’처럼 확실한 참고자료가 없는 만큼, 제품을 만드는 목적이 무엇인지, 어떤 용도와 특징을 담고 싶은지 등을 자세히 알려줘야 보다 정확한 견적을 매길 수 있습니다.`
    },
    {
      title: '‘치수’는 제품 각 부분 별로 꼼꼼하게 적어주세요',
      description: `참고용 이미지에 치수를 기재할 때는 부분 별로 꼼꼼하게 적어주는 것이 보다 정확한 견적을 받아보는 데 유리합니다.`
    },
    {
      title: '사진은 많을수록 좋습니다',
      description: `제품을 상하좌우전후 6면에서 바라본 이미지는 필수적으로 첨부하는 것이 좋습니다. 그 외에도 참고할 만한 레퍼런스가 있다면 해당 이미지나 링크를 함께 첨부해주세요.`
    }
  ]
};

export default howToContents;
